export default __webpack_public_path__ + "static/media/AceCenterLogo.f1d2bd49.png";